import React from "react";
import "../../css/components/StatsRow.css";

const stats = [
  {
    number: "£50",
    description: (
      <>
        A month is all it takes to begin building serious long-term wealth.
        Small beginnings. Meaningful results.
      </>
    ),
  },
  {
    number: "5",
    description: (
      <>
        Areas of your financial life brought together into one clear, living
        plan that adapts as your career evolves.
      </>
    ),
  },
  {
    number: "1",
    description: (
      <>
        Honest conversation. No hard sell. No jargon. Just clarity on where you
        are and what's possible.
      </>
    ),
  },
];

const StatsRow = () => (
  <div className="black-container">
    <div className="stats-row">
      {stats.map((stat, idx) => (
        <div className="stats-col" key={idx}>
          <h1 className="primary">{stat.number}</h1>
          <div className="content">{stat.description}</div>
        </div>
      ))}
    </div>
  </div>
);

export default StatsRow;
